var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "flex-container" },
      [
        _vm.timelines.length
          ? _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedTimelineId,
                    expression: "selectedTimelineId",
                  },
                ],
                staticClass: "selectbox",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedTimelineId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function ($event) {
                      return _vm.onChangeTimeline(_vm.selectedTimelineId)
                    },
                  ],
                },
              },
              [
                _vm.chronologyTimelines.length
                  ? _c("option", { attrs: { disabled: "" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("timelinePage.navigationBar.chronologyLabel")
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm._l(_vm.chronologyTimelines, function (timeline) {
                  return _c(
                    "option",
                    {
                      key: timeline.timelineId,
                      domProps: { value: timeline.timelineId },
                    },
                    [_vm._v(" " + _vm._s(timeline.name) + " ")]
                  )
                }),
                _vm.plotTimelines.length
                  ? _c("option", { attrs: { disabled: "" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("timelinePage.navigationBar.plotLabel"))
                      ),
                    ])
                  : _vm._e(),
                _vm._l(_vm.plotTimelines, function (timeline) {
                  return _c(
                    "option",
                    {
                      key: timeline.timelineId,
                      domProps: { value: timeline.timelineId },
                    },
                    [_vm._v(" " + _vm._s(timeline.name) + " ")]
                  )
                }),
              ],
              2
            )
          : _c("select", { staticClass: "selectbox disabled" }, [
              _c(
                "option",
                {
                  staticStyle: { display: "none" },
                  attrs: { disabled: "", selected: "" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("timelinePage.navigationBar.selectPlaceholder")
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
        _c(
          "button",
          {
            staticClass: "button",
            attrs: { disabled: !_vm.currentTimeline },
            on: { click: _vm.onClickEditTitle },
          },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("timelinePage.navigationBar.editTitle")) + " "
            ),
          ]
        ),
        _c("plus-circle-icon", {
          staticClass: "icon add",
          on: { click: _vm.onClickAdd },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex-container" },
      [
        _vm.currentTimeline
          ? _c("history-icon", {
              staticClass: "icon history",
              attrs: { fillColor: "#a0a0a0" },
              on: {
                click: function ($event) {
                  return _vm.$emit("showHistoryDialog")
                },
              },
            })
          : _vm._e(),
        _c("delete-icon", {
          staticClass: "icon delete",
          on: { click: _vm.onClickDelete },
        }),
      ],
      1
    ),
    _vm.isEditing ? _c("div", { staticClass: "navbar-mask" }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }